<span mat-button mat-dialog-close class="right pointer"><i id="closeOverlay" class="far fa-times-circle"></i></span>
<h1 mat-dialog-title>Reclamo per Consegna</h1>
<div mat-dialog-content>
  <form [formGroup]="deliveryComplaintForm" (ngSubmit)="onSubmit()" *ngIf="deliveryComplaintForm">
    <div class="grid-element-full">
        <textarea formControlName="complaintText" rows="5" placeholder="Scrivi reclamo message"></textarea>
        <app-error-html-handler [ctrl]="deliveryComplaintForm.get('complaintText')" [messages]="formValidationMsgs.complaintText"></app-error-html-handler>
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <div>
    <button mat-button class="btn" (click)=onSubmit() [disabled]="disableBtn || !deliveryComplaintForm.valid">
      Salva<i class="ml-10 far fa-save"></i>
    </button>
  </div>
</div>